import { useRecordContext } from 'react-admin'

import { ActionCommentSection, IncidentReportActionDialog, useActionSubmit } from './common'
import { INCIDENT_REPORT_ACTION_RESOLVE } from '../../../config/damages'

export const ResolveDamageReportFormDialog = ({ open, onClose }) => {
  const record = useRecordContext()
  const [submitAction, isLoading] = useActionSubmit(record.id, onClose)
  const onSubmitAction = (values) =>
    submitAction(
      INCIDENT_REPORT_ACTION_RESOLVE,
      { comment: values.comment || '' },
      'resources.incident-reports.actions.resolve.success',
    )

  return (
    <IncidentReportActionDialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      i18nPrefix="resources.incident-reports.actions.resolve"
      footerProps={{
        confirmLabelKey: 'resources.incident-reports.actions.resolve.confirmLabel',
        onSubmitAction,
      }}
    >
      <ActionCommentSection
        helperKey="resources.incident-reports.actions.resolve.commentHint"
        placeholderKey="resources.incident-reports.actions.fields.comment"
      />
    </IncidentReportActionDialog>
  )
}
